<template>
  <div>
    <v-row class="py-0">
      <v-col cols="3">
        <v-card max-width="300">
          <v-list shaped>
            <v-subheader class="font-italic text-subtitle-1">
              Pending Objectives
            </v-subheader>
            <v-divider></v-divider>
            <v-list-item-group color="dw_green">
              <v-list-item v-if="pendingObjectives.length === 0" disabled>
                <v-list-item-content>
                  <v-list-item-title>No objectives to review</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-else
                v-for="(objctv, i) in pendingObjectives"
                :key="i"
                @click="reviewObjective(objctv)"
                two-line
                dense>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-regular">
                    {{ objctv.pending_state.title }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption grey--text">
                    {{ pendingState(objctv.action) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col v-if="selectedObjective" cols="8">
        <v-form ref="reviewObjectiveForm" v-model="formValid" @submit.prevent>
          <v-card
            flat
            v-if="selectedObjective.action === 'UPD' && originalObjective"
            class="mb-3"
            outlined>
            <v-card-title class="py-2 text-h6 font-weight-light">Original Objective</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-2 px-8">
              <p class="mb-0">Name</p>
              <p class="mb-0 white--text">{{ originalObjective.title }}</p>
            </v-card-text>
          </v-card>
          <v-card flat outlined>
            <v-card-title class="py-2 text-h6 font-weight-light">
              Suggested Objective
              <v-spacer></v-spacer>
              <span class="text-body-2">{{ selectedObjective.submitted_by }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="px-4 py-0">
              <moderate-text-field
                ref="modField"
                :existing="selectedObjective.pending_state.title"
                label="Edit Objective Name *"
                @saveChanges="editObjective" />
            </v-card-text>
          </v-card>
          <v-row class="mt-12" no-gutters>
            <v-spacer></v-spacer>
            <v-btn
              type="button"
              :disabled="$refs.modField && $refs.modField.editField"
              @click="approveObjective"
              color="primary"
              small
              text>
              Approve
              <v-icon small color="primary" class="ml-2" v-text="mdiCheckOutline" />
            </v-btn>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiCheckOutline, mdiPencilOutline, mdiCloseOutline } from '@mdi/js';
import { mapActions, mapGetters } from 'vuex';
import moderateTextField from '@/components/forms/reviewModerations/moderateTextField.vue';
import utils from '@/utils';

export default {
  name: 'reviewObjectives',
  components: {
    moderateTextField
  },
  data: () => ({
    mdiCheckOutline,
    mdiPencilOutline,
    mdiCloseOutline,
    selectedObjective: undefined,
    formValid: false,
    originalObjective: undefined
  }),
  computed: {
    ...mapGetters([
      'pendingObjectives'
    ])
  },
  methods: {
    pendingState: utils.pendingState,
    ...mapActions([
      'moderateObjective',
      'fetchPending',
      'fetchOriginalByID',
      'fetchFilterOptions'
    ]),
    async approveObjective() {
      try {
        await this.moderateObjective({
          ...this.selectedObjective,
          approved: true
        });
        this.selectedObjective = undefined;
        this.fetchPending();
        this.fetchFilterOptions();
      } catch (err) {
        console.error(err);
      }
    },
    async reviewObjective(objective) {
      this.selectedObjective = objective;
      if (this.selectedObjective.action === 'UPD') {
        this.originalObjective = await this.fetchOriginalByID(['objective', this.selectedObjective.target]);
      }
    },
    async editObjective(newVal) {
      const changed = {
        ...this.selectedObjective,
        pending_state: {
          title: newVal
        }
      };
      try {
        await this.moderateObjective(changed);
        this.fetchPending();
        this.selectedObjective = changed;
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
